import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { getEncryptParams } from 'src/keycloak';
import type { DataApiInputParams } from 'src/types/api';
import { getPayload } from 'src/utils/encryption';

import type { Builder } from './utils';
import {
  getFormattedChatFilesData,
  getHeaders,
  getQueryString
} from './utils';

export default (builder: Builder) => {
  return {
    getHybridSearch: builder.query({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const queryString = getQueryString(arg.params);
        let url = `expert-advisor/hybrid-search${
          queryString.length ? '?' + queryString : ''
        }`;
        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}${queryString.length ? '&' : '?'}payload=${btoa(
            getPayload('', getEncryptParams())
          )}`;
        }
        const result: any = await fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });

        if (result.error) return result;

        return {
          data: getFormattedChatFilesData(result?.data?.data)
        };
      },
      providesTags: ['Permissions']
    }),
    getRecentFiles: builder.query({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const queryString = getQueryString(arg?.params);
        const url = `expert-advisor/recent-files${queryString.length ? '?' + queryString : ''}`;
        const result: any = await fetchWithBQ({
          url,
          ...getHeaders(url)
        });
        if (result.error) {return result;}
        const data = result?.data?.data;
        return {
          data: Array.isArray(data) ? data : []
        };
      },
      providesTags: ['AdvanceSearchRecentFiles']
    })
  };
};
